module.exports = __webpack_public_path__ + "img/icon-settings.2603af78.svg";